import type { ReactNode } from 'react';

export const symbol_tablet_camera: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M770-160v-580H190v580H99.8q-24.8 0-42.3-17.63Q40-195.25 40-220v-520q0-24.75 17.63-42.38Q75.25-800 100-800h760q24.75 0 42.38 17.62Q920-764.75 920-740v520q0 24.75-17.62 42.37Q884.75-160 860-160h-90ZM130-740h-30v520h30v-520Zm700 0v520h30v-520h-30Zm0 0h30-30Zm-700 0h-30 30ZM360-80q-25 0-42.5-17.5T300-140v-160q0-25 17.5-42.5T360-360h40l40-40h80l40 40h40q25 0 42.5 17.5T660-300v160q0 25-17.5 42.5T600-80H360Zm169.5-90.5Q550-191 550-220t-20.5-49.5Q509-290 480-290t-49.5 20.5Q410-249 410-220t20.5 49.5Q451-150 480-150t49.5-20.5Z"
		/>
	</svg>
);
